<template>
  <div class="contain">
    <div class="title">
      {{dataTitle}}
    </div>
    <div class="contain-info">
      <div class="video-info">
        <div class="video-info-left">
          <video  loop="loop" muted  autoplay="autoplay">
            <source src="../assets/video/3dvideo.mp4" type="video/mp4">
          </video>
        </div>
        <div class="video-info-right">
          <div class="video-info-right-info">
<!--            <img src="@/assets/img/zitai/3dvideoinfo.png" alt="">-->
            <div>本产品运用基于多通道视景同步技术和立体显示技术的CAVE空间投影，结合虚拟仿真技术，通过实时渲染，为使用者呈现可体验、可互动、高拟真的三维立体可视协同环境，让使用者瞬间穿越时空、穿越维度、超越感官，体会到如真似幻的梦幻未来。</div>
            <div style="margin-top:20px">在教育领域，该产品可为师生提供高度交互、虚实结合的教学环境和实训环境，让学生学习更有趣，教师教学更轻松，实训体验更丰富。</div>

          </div>
        </div>
      </div>
    </div>
    <div class="contain-bottom">
      <div class="contain-bottom-content" v-for="(items,index) in dataList">
        <div class="contain-bottom-content-img">
          <img :src="items.logo" alt="">
        </div>
        <div class="contain-bottom-content-title">
          <div>{{items.title}}</div>
        </div>
        <div class="contain-bottom-content-info">
<!--          <img :src="items.src" alt="">-->
          {{items.content}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cishidai.vue",
  components: {
  },
  data () {
    return {
      dataTitle:'次世代裸眼3D',
      dataList:[
        {
          title:'身临其境',
          logo:require("../assets/img/zitai/imgs3.png"),
          // src:require("../assets/img/zitai/contentinfo3.png")
          content:'运用CVAE空间投影技术，将次时代引擎制作的虚拟场景，投影在现实空间。使用者仿佛亲身降临拟场景，体验强烈的现场冲击力。'
        },
        {
          title:'身入虚境',
          logo:require("../assets/img/zitai/imgs2.png"),
          // src:require("../assets/img/zitai/contentinfo2.png")
          content: '基于人工智能和多目视觉技术，通过识别、提取、分析使用者的身、手、眼等3D位姿信息，重置现实和虚拟，达到人景结合的效果。'
        },
        {
          title:'身入幻境',
          logo:require("../assets/img/zitai/imgs1.png"),
          // src:require("../assets/img/zitai/contentinfo1.png")
          content:'使用者无需任何设备，直接通过肢体语言，便可对虚拟场景下达指令，与虚拟仿真环境互动，在现实世界呈现出科幻般的未来场景。'
        }
      ]
    }
  },
  methods: {

  },

}
</script>

<style lang="scss" scoped>
@import '../assets/css/Cihidai.scss';
</style>


